var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('v-app-bar',{attrs:{"app":"","color":"#212121","dark":"","hide-on-scroll":"","max-height":"80"}},[_c('div',{staticClass:"d-flex align-center logobox"},[_c('a',{attrs:{"href":"https://bettercoffee.link"}},[_c('span',{staticClass:"logo"},[_vm._v("Better Coffee")])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }